module.exports = __webpack_public_path__ + "static/media/practice.a1660322.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/practice.png
// module id = 3540
// module chunks = 3